import { render } from "./privacy-policy.vue?vue&type=template&id=74b2ee35&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=74b2ee35&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b2ee35"]])

export default __exports__